
/*
// Base structure of a message
{
  type: String,             // MESSAGE_TYPE
  from: String,             // Filled in backend
  room: String,             // Filled in backend
  timestamp: Int,           // Filled in backend, UNIX
  data: {
    text: String,
    settings: {             // Only in Broadcast
      usernameColor: String // Hex format
    }
  }
}
*/

// Possible types of message
export const MESSAGE_TYPE = {
  LOGIN_SUCCESS: 'LoginSuccess',
  LOGIN_ERROR: 'LoginError',
  ERROR: 'Error',
  BROADCAST: 'Broadcast'
}

// Makes message to send to backend
export function newBroadcastMessage ({ text, usernameColor }) {
  return {
    type: MESSAGE_TYPE.BROADCAST,
    data: {
      text: text,
      settings: {
        usernameColor: usernameColor
      }
    }
  }
}

// Internal error message (used only in frontend)
export function newErrorMessage (text) {
  return {
    type: MESSAGE_TYPE.ERROR,
    id: generateID(),
    timestamp: getHoursAndMinutes(new Date()),
    data: {
      text: text
    }
  }
}

// Serialize message to sent to backend
export function messageToJSON (message) {
  return JSON.stringify({
    type: message.type,
    data: message.data
  })
}

// Deserialize message received from backend
export function messageFromJSON (message) {
  let rawMessage = JSON.parse(message)

  rawMessage.id = generateID()

  const date = dateFromTimestamp(rawMessage.timestamp)
  rawMessage.timestamp = getHoursAndMinutes(date)

  return rawMessage
}

function generateID () {
  let S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  return `${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`
}

function dateFromTimestamp (timestamp) {
  return new Date(timestamp * 1000)
}

function getHoursAndMinutes (date) {
  return date.toLocaleTimeString(navigator.language, {
    hour: '2-digit',
    minute: '2-digit'
  })
}



// WEBPACK FOOTER //
// ./src/models/message.js